import { render } from "./AIAuditLog.vue?vue&type=template&id=55acba1f"
import script from "./AIAuditLog.vue?vue&type=script&lang=js"
export * from "./AIAuditLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__